import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SortIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sort"}/>
}
